import { Record } from 'immutable';
import PastBookingGroup from 'models/past-booking-group';

export default class PastBookings extends Record({
  allBookings: new PastBookingGroup(),
  businessBookings: new PastBookingGroup(),
  refundedBookings: new PastBookingGroup(),
}) {}
